import React from 'react'
import { connect } from 'react-redux'
import { fetchMemberCampaignsAndBoards, fetchDonorDetails, fetchBoardDetails, campaignLiveToggle } from '../../../redux/member/actions'

import PageMessage from '../../components/PageMessage'
import NextUpdate from '../../components/NextUpdate'
import SubNav from '../../components/SubNav'
import Fundraisers from './Fundraisers'
import Boards from './Boards'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

function TabPanel(props) {
  	const { children, value, index, ...other } = props;
  	return (
    	<div role='tabpanel' hidden={value !== index} id={`nav-tabpanel-${index}`} {...other} >
      	{value === index && ( children )}
    	</div>
  	)
}

class MemberCampaignsContainer extends React.Component {
	mounted = true
	state = {
		activeTab: 0,
		pageLoading: true,
		pageTitle: undefined,	//Not Found',
		pageText: undefined	//The campaign you are looking for was not found',
  	}
	componentDidMount = () => {
		this.handleFetchCampaignsAndBoards(false)
	}
	componentWillUnmount = () => {
		this.mounted = false
	}
	handleFetchCampaignsAndBoards = (force) => {
	 	return new Promise((resolve, reject) => {
		 	let _this = this
		 	this.props.fetchMemberCampaignsAndBoards(force)
		 	.then(() => {
		 		if(_this.mounted) {
		 			_this.setState({ pageLoading:false })
		 		}
		 	})	
		 	.catch((e) => {
		 		if(_this.mounted) {
		 			_this.setState({ pageLoading:false, pageTitle:e.title, pageText:e.message })
		 		}
		 	})	
		 	.finally(() => {
		 		resolve()
		 	})		
	 	})
	}
  	handleChange = (event, newValue) => {
  		this.setState({activeTab:newValue})
  	}
  	render() {
  		const {activeTab, pageLoading, pageTitle, pageText} = this.state
  		const {boards, campaigns, lastUpdated, fetchDonorDetails, fetchBoardDetails, campaignLiveToggle} = this.props

    	if(pageLoading || pageTitle) {
			return (<PageMessage pageLoading={pageLoading} pageTitle={pageTitle} pageText={pageText} />)
		}

    	return (
   		<React.Fragment>
   		<Container maxWidth='lg' style={{ padding: 10, marginBottom: 50 }}>
				<Grid container justify='center' spacing={2}>
					<Grid item xs={12} sm={12} md={10} >
						<SubNav text='Campaigns' buttonText='New Campaign' buttonLink='/member/campaign/'/>
					
						<div style={{borderBottom: '2px solid #eee'}}>  
						  	<Tabs
						    	value={activeTab}
						    	onChange={this.handleChange}
						    	variant='fullWidth'
						    	indicatorColor='primary'
						    	textColor='primary'							    
						  	>
						    	<Tab label='Fundraisers' />
						    	<Tab label='Boards' />
						  	</Tabs>
						</div>

						<TabPanel value={activeTab} index={0}>
				        	<Fundraisers campaigns={campaigns} fetchDonorDetails={fetchDonorDetails} campaignLiveToggle={campaignLiveToggle}/>
				      </TabPanel>
				      <TabPanel value={activeTab} index={1}>
				        	<Boards boards={boards} fetchBoardDetails={fetchBoardDetails}/>
				      </TabPanel>
					</Grid>
				</Grid>
				<NextUpdate lastUpdated={lastUpdated} updateNow={this.handleFetchCampaignsAndBoards}/>
			</Container>
   		</React.Fragment>
    	)
  	}
} 
const mapStateToProps = (state) => ({
	boards: state.member.boards,
	campaigns: state.member.campaigns,
	lastUpdated: state.app.lastUpdated.memberCampaignsAndBoards
})
const mapDispatchToProps = {
	fetchMemberCampaignsAndBoards,
	fetchDonorDetails,
	fetchBoardDetails,
	campaignLiveToggle	
}
export default connect(mapStateToProps, mapDispatchToProps)(MemberCampaignsContainer)
